import mwcMarketsCore from 'mwc-markets-core';
import SectorHeatmap from './src/sector-heatmap';

const { createCustomElement } = mwcMarketsCore;
createCustomElement(SectorHeatmap);

export default SectorHeatmap;
